import { IconButton } from '@mui/material'
import { darken, styled } from '@mui/material/styles'

export const CircleIconButton = styled(IconButton)<{
  isCondensedWidth?: boolean
}>(({ theme, isCondensedWidth }) => ({
  border: '1px solid #e4e4e4',
  boxShadow: '1px 1px 6px 0px rgba(50, 50, 71, 0.05)',
  background: 'white',
  ...(isCondensedWidth && {
    border: 'none',
    boxShadow: 'none'
  }),
  '@media (max-height: 500px)': {
    border: 'none',
    boxShadow: 'none',
    width: '38px',
    height: '38px'
  }
}))
